import {HttpClient} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {FUSE_VERSION} from '@fuse/version';
import {Translation, TranslocoLoader} from '@ngneat/transloco';
import {Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class TranslocoHttpLoader implements TranslocoLoader
{
    private _httpClient = inject(HttpClient);

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get translation
     *
     * @param lang
     */
    getTranslation(lang: string): Observable<Translation>
    {
        // Cache-bust per release so deploys don't serve stale translation files.
        return this._httpClient.get<Translation>(`./assets/i18n/${lang}.json?v=${FUSE_VERSION}`);
    }
}
